import React from 'react';
import { TransHtml, useLocale } from '../i18n/LocaleContext';
import { MiniChat, MiniClubCard, MiniEventCard, MiniPost } from './MiniApp';
import { COVERS } from '../data/pexels';

const FeedVisual = (): React.JSX.Element => (
  <div className="m-feat-rail">
    <MiniEventCard
      tone="gradient"
      coverUrl={COVERS.ghosts}
      clubName="Golden Hour"
      authorFirst="Mia"
      authorLast="K."
      title="Sunset vinyl rooftop"
      date="Tonight · 19:00"
      city="Košice"
      ribbon="3 left"
      attendees={[
        { first: 'Tom', last: 'B.' },
        { first: 'Lia', last: 'P.' },
        { first: 'Sam', last: 'R.' },
      ]}
    />
    <MiniEventCard
      tone="purple"
      coverUrl={COVERS.sunset}
      clubName="Sunday Runners"
      authorFirst="Tom"
      authorLast="B."
      title="Saturday 5k loop"
      date="Sat · 08:00"
      city="Bratislava"
      attendees={[
        { first: 'Ana', last: 'D.' },
        { first: 'Jan', last: 'K.' },
        { first: 'Ivo', last: 'S.' },
      ]}
    />
  </div>
);

const ClubsVisual = (): React.JSX.Element => (
  <div className="m-feat-rail">
    <MiniClubCard
      tone="purple"
      coverUrl={COVERS.palms}
      name="Sunday Runners"
      ownerFirst="Mia"
      ownerLast="K."
      price="Free"
      members="248"
    />
    <MiniClubCard
      tone="orange"
      coverUrl={COVERS.jukebox}
      name="Golden Hour"
      ownerFirst="Tom"
      ownerLast="B."
      price="$4/mo"
      members="132"
      joined
    />
  </div>
);

const ChatVisual = (): React.JSX.Element => (
  <MiniChat
    eventName="Sunset vinyl rooftop"
    participants="12 participants"
    coverUrl={COVERS.car}
    messages={[
      { first: 'Mia', last: 'K.', text: "who's bringing vinyl?", time: '18:42' },
      { me: true, text: "i've got a stack 🎶", time: '18:43' },
      { first: 'Tom', last: 'B.', text: 'legend. on my way.', time: '18:44' },
      { first: 'Ana', last: 'D.', text: 'bringing snacks + wine 🍷', time: '18:45' },
      { me: true, text: '🔥🔥', time: '18:45' },
      { first: 'Jan', last: 'K.', text: 'running 10 min late', time: '18:47' },
      { me: true, text: 'see u all at 7 🧡', time: '18:48' },
    ]}
  />
);

const PostVisual = (): React.JSX.Element => (
  <div className="m-feat-stack m-feat-stack--row">
    <MiniPost
      authorFirst="Mia"
      authorLast="K."
      fromLabel="from Rooftop event"
      date="2h · today"
      content="what an evening. thanks to everyone who showed up with records 🎶"
      imageTone="gradient"
      imageUrl={COVERS.diner}
      likes={48}
      comments={12}
    />
    <MiniPost
      authorFirst="Tom"
      authorLast="B."
      fromLabel="from Sunday Runners"
      date="Yesterday"
      content="morning loop, new route along the river. same time next week?"
      imageTone="purple"
      imageUrl={COVERS.beach}
      likes={21}
      comments={6}
    />
  </div>
);

type FeatDef = {
  span: 'span-7' | 'span-5' | 'span-4' | 'span-8';
  hero?: boolean;
  numKey: string;
  headKey: string;
  pKey: string;
  visual: () => React.JSX.Element;
  aspect?: string;
  modifier?: string;
};

const FEATS: FeatDef[] = [
  { span: 'span-7', numKey: 'feat.1.num', headKey: 'feat.1.h', pKey: 'feat.1.p', visual: FeedVisual, aspect: '16/8' },
  { span: 'span-5', numKey: 'feat.2.num', headKey: 'feat.2.h', pKey: 'feat.2.p', visual: ClubsVisual },
  { span: 'span-4', numKey: 'feat.3.num', headKey: 'feat.3.h', pKey: 'feat.3.p', visual: ChatVisual, aspect: '2/3' },
  { span: 'span-8', numKey: 'feat.4.num', headKey: 'feat.4.h', pKey: 'feat.4.p', visual: PostVisual, modifier: 'm-feat--dark', aspect: '3/2' },
];

export const FeaturesSection = (): React.JSX.Element => {
  const { t } = useLocale();

  return (
    <section id="features">
      <div className="wrap">
        <div className="features-head">
          <div>
            <span className="eyebrow">{t('feat.eyebrow')}</span>
            <TransHtml tag="h2" tKey="feat.h2" style={{ marginTop: 12 }} />
          </div>
          <p>{t('feat.sub')}</p>
        </div>

        <div className="features-grid">
          {FEATS.map((f, i) => {
            const Visual = f.visual;
            const classes = ['feat-visual', 'm-feat', f.modifier].filter(Boolean).join(' ');
            return (
              <div key={i} className={`feat ${f.span}${f.hero ? ' hero-feat' : ''}`}>
                <span className="num">{t(f.numKey)}</span>
                <TransHtml tag="h3" tKey={f.headKey} />
                <p>{t(f.pKey)}</p>
                <div className={classes} style={f.aspect ? { aspectRatio: f.aspect } : undefined}>
                  <Visual />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
